<template>

    <div class="text-center">
        <div v-if="$slots.default" class="mb-4 text-xs text-blue-600 text-base">
            <slot></slot>
        </div>
        <div class="card-spinner">
            <div class="card-bounce1" :style="`background-color: ${color}`"></div>
            <div class="card-bounce2" :style="`background-color: ${color}`"></div>
            <div class="card-bounce3" :style="`background-color: ${color}`"></div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            color: {
                default: '#000000'
            }
        },
        data() {
            return {
            }
        },
    }
</script>

<style scoped>
    .card-spinner {
        width: 50px;
        text-align: center;
        margin: 0 auto;
    }

    .card-spinner > div {
        width: 8px;
        height: 8px;
        background-color: #fff;
        margin-right: 4px;

        border-radius: 100%;
        display: inline-block;
        -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }
    .card-spinner.card-spinner-blue > div {
        background-color: #1D5091;
    }

    .card-spinner .card-bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }

    .card-spinner .card-bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
        0%, 80%, 100% { -webkit-transform: scale(0) }
        40% { -webkit-transform: scale(1.0) }
    }

    @keyframes sk-bouncedelay {
        0%, 80%, 100% {
            -webkit-transform: scale(0);
            transform: scale(0);
        } 40% {
              -webkit-transform: scale(1.0);
              transform: scale(1.0);
          }
    }
</style>